<!--
 * @Author: lsr lsr@qq.com
 * @Date: 2022-05-13 11:10:26
 * @LastEditors: lsr lsr@qq.com
 * @LastEditTime: 2022-05-18 17:20:21
 * @FilePath: \YHB_H5\src\pages\download\index_1.vue
 * @Description: 下载页面
-->
<template>
	<div class="download-content">
		<h1 class="title">成就平凡人的创业梦想</h1>
		<img src="../../assets/down_bg.png" alt="易伙伴app" />
		<div class="download-bottom"><van-button class="download-btn" type="default" @click="download">下载易伙伴Pro</van-button></div>
	</div>
</template>

<script>
import { downloadApp } from '@/api/index';
import { Toast } from 'vant';
export default {
	data() {
		return {
			browser: false,
			copyUrl: 'http://app.yhbzf.com:8089/download'
		};
	},
	mounted() {
		this.getisweixing();
		if (this.browser) {
			Toast({
				message: '请点击右上角选择在浏览器中打开',
				duration: 3000
			});
		}
	},
	// 解决微信浏览器中页面跳转url路径不变问题
	created() {
		let _href = window.location.href // 获取当前地址
		if(_href.indexOf('?replace=1') <= -1){ // 若没有replace参数，则添加进去
		window.location.replace(_href+'?replace=1')
		}
	},

	methods: {
		// 判断是否在 微信浏览器
		getisweixing() {
			var wx = window.navigator.userAgent.toLowerCase();
			if (wx.match(/MicroMessenger/i) == 'micromessenger') {
				// console.log('是微信浏览器默认走微信')
				this.browser = true;
				return true; // 是微信端
			} else {
				// console.log('不是微信浏览器绘制原生。');
				this.browser = false;
				return false;
			}
		},
		// 下载
		async download() {
			if (this.browser) {
				Toast({
					message: '请点击右上角选择在浏览器中打开',
					duration: 3000
				});
				return;
			}
			await downloadApp('YHB').then(res => {
				console.log(res);
				let u = navigator.userAgent;
				let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
				if (isAndroid) {
					window.location.href = res.msg;
					this.copyUrl = res.msg;
				} else {
					window.location.href = `itms-apps://itunes.apple.com/app/id1587458887?mt=8`;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.download-content {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	.title {
		font-size: 30px;
		font-family: PangMenZhengDao;
		color: #333333;
		text-shadow: 0px 2px 4px #ffffff;
		text-align: center;
	}
	img {
		max-width: 100%;
		user-select: none;
	}
	.download-bottom {
		text-align: center;
		padding-bottom: 50px;
		.download-btn {
			background: #fa9718;
			border-radius: 21px;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			padding: 0 73px;
			letter-spacing: 1px;
		}
	}
}
</style>
